<template>
  <v-col cols="12" sm="4">
    <v-hover v-dlot="{hover}" open-delay="200">
      <v-card color="red lighten-5" :elevation="hover ? 16 : 2">
        <div class="d-flex flex-column justify-space-between align-center">
          <v-img src="{item.img}" min-height="80" max-height="80" max-width="150"></v-img>
        </div>
        <v-app-bar flat color="rgb(0,0,0,0)">
          <h5 class="ml-1 grey--text text-lighten-3">{{item.name}}</h5>
        </v-app-bar>
      </v-card>
    </v-hover>
  </v-col>
</template>

<script>
export default {
  props: ['item']
}
</script>

<style>
</style>